import { useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from "notistack";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, Box, Typography, Checkbox, FormControlLabel, FormGroup, CircularProgress, InputAdornment, Tooltip, Link } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import ProRateDetails from './ProRateDetails';
import RangeConditionTable from './RangeCondition';
import CustomTable from './CustomTable';
import AdvanceArrearsDetails from './AdvanceArrearsDetails';
import { addRentalRateApi, updateRentalRateApi, getConsantApi, getMajorAssemblyApi, getCurrencyApi, getProductServiceDropdownApi, getChartOfAccountDropdownApi, getClassesDropdownApi, getSubClassesDropdownApi } from '../apiService';
import { getQbStatusApi } from '../../quickBooks/apiService';
import { getAccountTypeListApi } from '../../settings/AccountType/apiService';
import useValidationHook from '../hooks/useValidationHook';
import { CustomRatioDerateTable, DerateBasedRatioTable,InterpolationExtrapolation } from '../../elements';
import { globalPutService, globalPostService, globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus, numberWithCommas } from '../../../utils';
import { PageLoader, hanwahaInstance, jetStreamInstance } from '../../../shared_elements';
import { AttachementsUpload } from '../../../shared_elements/components';
import { backendDateFormat, displayDateFormatShort, fieldDateFormat } from '../../../constants';
import { regexConstants } from '../../../constants/regEx';
import { isValidYearRange } from '../../../utils/helper';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { formatBytes } from '../../../utils/fileUpload';
import { trackActivity } from '../../../utils/mixpanel';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const fixedTableDefaults = { fixed: null, daily: null, fc_rate: null, fh_rate: null };
const normalizeFixedTableCondition = (condition) => ({ ...fixedTableDefaults, ...(condition || {}) });
const normalizeFixedTableFlag = (value) => value === true || value === "true" || value === 1;

const RentalRateCRU = ({ addEditRentalRates, fileUpload, getResponseBack, onToggleModal, modeType, onOpenAttachments, onImportBackup }) => {
    const navigate=useNavigate();
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const { storageDetails } = useSelector((state) => state.leases);
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    const [qbStatusLoading, setQbStatusLoading] = useState(jetStreamInstance || hanwahaInstance);
    const [isLoading, setLoading] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [error, setError] = useState({});
    const [pbhErrors, setPbhErrors] = useState({});
    const updatedRentalData = {
        ...addEditRentalRates?.data,
        escalation_percentage: addEditRentalRates?.data?.escalation_percentage && addEditRentalRates?.data?.escalation_percentage !== null ? addEditRentalRates?.data?.escalation_percentage : "",
        escalation_interval: addEditRentalRates?.data?.escalation_interval ? addEditRentalRates?.data?.escalation_interval : null,
        escalation_start_date: addEditRentalRates?.data?.escalation_start_date ? addEditRentalRates?.data?.escalation_start_date : null,
        // round_off_escalation: addEditRentalRates?.data?.round_off_escalation ? addEditRentalRates?.data?.round_off_escalation : null,
        interval_condition: addEditRentalRates?.data?.interval_condition ? addEditRentalRates?.data?.interval_condition.map(item => ({
            ...item,
            ...(item.rate != null && { rate: Number(item.rate) }),
            ...(item.min_value != null && { min_value: Number(item.min_value) }),
            ...(item.max_value != null && { max_value: Number(item.max_value) }),
            ...(item.ratio != null && { ratio: Number(item.ratio) }),
            ...(item.derate != null && { derate: Number(item.derate) }),
            ...(item.ratios && { ratios: item.ratios.map(r => ({
                ...r,
                ...(r.rate != null && { rate: Number(r.rate) }),
                ...(r.ratio != null && { ratio: Number(r.ratio) }),
            }))}),
        })) : [],
        pbh_conditions: addEditRentalRates?.data?.pbh_conditions?.map(item => ({
            ...item,
            min_value: item.min_value != null ? Number(item.min_value) : 0,
            max_value: item.max_value != null ? Number(item.max_value) : 0,
            ...(item.rate != null && { rate: Number(item.rate) }),
        })),
        is_advanced: addEditRentalRates?.data?.is_advanced === undefined ? true : addEditRentalRates?.data?.is_advanced === true ? true : false,
        is_arrears: addEditRentalRates?.data?.is_arrears ? true : null,
        // is_interpolation: addEditRentalRates?.data?.is_interpolation === true ? 1 : null,
        // is_extrapolation: addEditRentalRates?.data?.is_extrapolation === true ? 2 : null,
        account_type : addEditRentalRates?.data?.account_type ? addEditRentalRates?.data?.account_type : null,
        interpolation_option: addEditRentalRates?.data?.interpolation_option ? addEditRentalRates?.data?.interpolation_option?.value : null,
        extrapolation_option: addEditRentalRates?.data?.extrapolation_option ? addEditRentalRates?.data?.extrapolation_option?.value : null,
        allow_decimal: addEditRentalRates?.data?.allow_decimal ? { ...addEditRentalRates?.data?.allow_decimal, value: addEditRentalRates?.data?.allow_decimal } : null,
        is_pbh_fixed_table: normalizeFixedTableFlag(addEditRentalRates?.data?.is_pbh_fixed_table),
        fixed_rate: normalizeFixedTableFlag(addEditRentalRates?.data?.fixed_rate),
        fixed_table_condition: normalizeFixedTableCondition(addEditRentalRates?.data?.fixed_table_condition),
        daily_rent: normalizeFixedTableFlag(addEditRentalRates?.data?.daily_rent),
    }
    const [data, setData] = useState(updatedRentalData)
    const [attachments, setAttachments] = useState([]);
    const [pltConstants, setPltConstants] = useState({ constant_types: [], asset_types: [], currencies: [], rate_account_types: [] });
    const [dropDownloader, setDropDownLoader] = useState({ currency: false, constantType: false, majorAssembly: false, rateAccountType: false })
    const [productServices, setProductServices] = useState([]);
    const [chartOfAccounts, setChartOfAccounts] = useState([]);
    const [classes, setClasses] = useState([]);
    const [subClasses, setSubClasses] = useState([]);
    const [qbDropDownLoader, setQbDropDownLoader] = useState({ productService: false, chartOfAccount: false, class: false, subClass: false });
    const { enqueueSnackbar } = useSnackbar();
    const { checkRatioValidation, checkRangeConditionsValiadation } = useValidationHook()
    const getPltConstants = () => {
        setDropDownLoader(prev => ({ ...prev, constantType: true }))
        globalPostService(getConsantApi(), { constant_types: ['rental_type', "rental_rate_type", 'interval', "thrust_category", "rate_range_condition", "escalation_interval", 'rental_account_type', 'unit_of_measure', /* 'round_off_escalation' */] })
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, constantType: false }))
                if (checkApiStatus(response)) {
                    // const escalationIntervalArr = response?.data?.data?.filter(value => value?.type === "escalation_interval")
                    // const defaultEscInterval = escalationIntervalArr?.filter((interval => interval?.label === "Annual"))
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        constant_types: response.data.data || []
                    }));
                    // setData(prev => ({ ...prev, rate_escalation_interval: defaultEscInterval && defaultEscInterval[0] }));
                }
            })
    }

    const getCurrency = () => {
        setDropDownLoader(prev => ({ ...prev, currency: true }))
        globalGetService(getCurrencyApi(params))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, currency: false }))
                if (checkApiStatus(response)) {
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        currencies: response.data.data || []
                    }));
                }
            })
    }
    const getRateAccountTypes = () => {
        setDropDownLoader(prev => ({ ...prev, rateAccountType: true }))
        globalGetService(getAccountTypeListApi({ lite: true, applicable_for: 1 }))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, rateAccountType: false }))
                if (checkApiStatus(response)) {
                    const list = response?.data?.data?.list || [];
                    setPltConstants(prev => ({
                        ...prev,
                        rate_account_types: list
                    }));
                }
            })
    }
    const getMajorAssembly = (accountType) => {
        setDropDownLoader(prev => ({ ...prev, majorAssembly: true }))
        globalGetService(getMajorAssemblyApi(params))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, majorAssembly: false }))
                if (checkApiStatus(response)) {
                    // let updatedMajorAssembly
                    // if (accountType === 1) {
                    //     updatedMajorAssembly = response?.data?.data?.filter(data => data.asset_type === 2)
                    // } else {
                    //     updatedMajorAssembly = response?.data?.data
                    // }
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        asset_types: response?.data?.data || []
                    }));
                }
            })
    }
    useEffect(() => {
        getPltConstants()
        getCurrency()
        getRateAccountTypes()
        getMajorAssembly()
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response) && response.data.data?.is_lessor_enabled) {
                setIsQbEnabled(true)
                getProductServices()
                getChartOfAccountsList()
                if (hanwahaInstance) getClassesList()
            }
            setQbStatusLoading(false)
        })
    }, [])

    useEffect(() => {
        const classId = data?.qb_class_id?.id;
        setSubClasses([]);
        if (!hanwahaInstance || !classId) {
            return;
        }
        setQbDropDownLoader(prev => ({ ...prev, subClass: true }))
        globalGetService(getSubClassesDropdownApi(classId, leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, subClass: false }))
                if (checkApiStatus(response)) {
                    setSubClasses(response.data.data)
                }
            })
    }, [data?.qb_class_id])

    const getProductServices = () => {
        setQbDropDownLoader(prev => ({ ...prev, productService: true }))
        globalGetService(getProductServiceDropdownApi(leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, productService: false }))
                if (checkApiStatus(response)) {
                    setProductServices(response.data.data)
                }
            })
    }

    const getChartOfAccountsList = () => {
        setQbDropDownLoader(prev => ({ ...prev, chartOfAccount: true }))
        globalGetService(getChartOfAccountDropdownApi(leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, chartOfAccount: false }))
                if (checkApiStatus(response)) {
                    setChartOfAccounts(response.data.data)
                }
            })
    }

    const getClassesList = () => {
        setQbDropDownLoader(prev => ({ ...prev, class: true }))
        globalGetService(getClassesDropdownApi(leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, class: false }))
                if (checkApiStatus(response)) {
                    setClasses(response.data.data)
                }
            })
    }

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };
    const prepareEscalationConditions = (key, updatedValues, value) => {
        const isEdit = modeType === "edit"
        if (data?.[key]?.length > 0) {
            updatedValues[key] = (isEdit && value === updatedRentalData?.table_based_esc)
                ? (
                    data?.[key]?.map(item => {
                        const prev = updatedRentalData?.[key]?.find(u => u.id === item.id);
                        return prev
                            ? { ...item, esc_percentage: prev.esc_percentage, esc_date: prev.esc_date }
                            : { ...item, esc_percentage: 0, esc_date: null };
                    })
                )
                : (
                    data?.[key]?.map(item => ({
                        ...item,
                        esc_percentage: 0,
                        esc_date: null
                    }))
                );
        }
    }

    const onFieldChange = (key, value) => {
        const isEdit = modeType === "edit"
        const updatedValues = { [key]: value, };
        const isSame = (field, compareVal = value?.value) => isEdit && updatedRentalData?.[field]?.value === compareVal;
        const fieldDefaults = {  major_assembly: null, rental_rate_based_on: null, unit_of_measurement: null, interval: null, interval_condition: [], pbh_conditions: [], custom_payments: [], range_condition_to_consider: null, table_based_esc: false, rate_escalation_percentage: "", rate_escalation_start_date: null, rate_escalation_interval: null, is_interpolation: false, is_extrapolation: false, interpolation_option: null, extrapolation_option: null, is_pbh_fixed_table: false, fixed_rate: false, fixed_table_condition: fixedTableDefaults, daily_rent: false, /* round_off_escalation: null */ };
        const groupByFieldType = {
            rental_type: ["rental_rate_based_on", "unit_of_measurement", "interval", "interval_condition", "pbh_conditions", "custom_payments", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_interpolation", "is_extrapolation", "interpolation_option", "extrapolation_option", "range_condition_to_consider", "allow_decimal", "rounding", "is_base_reading", "major_assembly", "currency", "amount", "is_pbh_fixed_table", "fixed_rate", "fixed_table_condition", "daily_rent", /* "round_off_escalation" */],
            rental_rate_based_on: ["interval", "interval_condition", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_interpolation", "is_extrapolation", "interpolation_option", "extrapolation_option", "allow_decimal", "rounding", "is_base_reading", /* "round_off_escalation" */],
            unit_of_measurement: ["interval", "pbh_conditions", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_pbh_fixed_table", "fixed_rate", "fixed_table_condition", "daily_rent", /* "round_off_escalation" */],
            major_assembly: ["rental_rate_based_on", "interval_condition", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_interpolation", "is_extrapolation", "interpolation_option", "extrapolation_option", "allow_decimal", "rounding", "is_base_reading", "unit_of_measurement", "is_pbh_fixed_table", "fixed_rate", "fixed_table_condition", "daily_rent", /* "round_off_escalation" */],
        }
        const applyFields = (updatedValues, updatedData, fields, condition) => {
            fields.forEach((field) => {
                updatedValues[field] = condition
                    ? updatedData?.[field] ?? fieldDefaults[field]
                    : fieldDefaults[field];
            });
        }
        if (key === "rental_type") {
            const sameRentalType = isSame("rental_type")
            applyFields(updatedValues, updatedRentalData, groupByFieldType.rental_type, sameRentalType);
        }
        else if (key === "major_assembly") {
            const sameMajorAssembly = updatedRentalData?.major_assembly?.asset_id === value?.id && updatedRentalData?.rental_type?.value === data?.rental_type?.value
            applyFields(updatedValues, updatedRentalData, groupByFieldType.major_assembly, sameMajorAssembly);
        }
        else if (key === "rental_rate_based_on") {
            const sameRentalRateBased = isSame("rental_rate_based_on")
            updatedValues.unit_of_measurement = null;
            updatedValues.pbh_conditions = [];
            applyFields(updatedValues, updatedRentalData, groupByFieldType.rental_rate_based_on, sameRentalRateBased);
        }
        else if (key === "unit_of_measurement") {
            const sameUnitOfMeasureBased = isSame("unit_of_measurement")
            updatedValues.rental_rate_based_on = null;
            updatedValues.interval_condition = [];
            applyFields(updatedValues, updatedRentalData, groupByFieldType.unit_of_measurement, sameUnitOfMeasureBased);
        }
        else if (key === "range_condition_to_consider") {
            const isFixedTable = value === "fixed";
            const isFixedRate = value === "fixed_rate";
            updatedValues.is_pbh_fixed_table = isFixedTable;
            updatedValues.fixed_rate = isFixedRate;
            updatedValues.range_condition_to_consider = isFixedTable || isFixedRate ? data?.range_condition_to_consider : value;
            updatedValues.fixed_table_condition = isFixedTable ? normalizeFixedTableCondition(data?.fixed_table_condition) : data?.fixed_table_condition;
            updatedValues.daily_rent = isFixedTable ? data?.daily_rent : false;
            // if (data?.is_pbh_fixed_table !== isFixedTable) {
            //     const pbhFixedMatch = isEdit && updatedRentalData?.account_type?.value === data?.account_type?.value && updatedRentalData?.major_assembly?.asset_slug === data?.major_assembly?.asset_slug && updatedRentalData?.rental_type?.value === data?.rental_type?.value && updatedRentalData?.unit_of_measurement?.value === data?.unit_of_measurement?.value && isFixedTable === updatedRentalData?.is_pbh_fixed_table;
            //     updatedValues.round_off_escalation = pbhFixedMatch ? updatedRentalData?.round_off_escalation : null;
            // }
            if (!isFixedTable) {
                setError(prev => { const next = { ...prev }; delete next.fixed_table_condition; return next; });
            }
        }
        else if (key === "daily_rent") {
            updatedValues.fixed_table_condition = { ...normalizeFixedTableCondition(data?.fixed_table_condition), ...(value ? { fixed: "" } : { daily: "", fixed: addEditRentalRates?.data?.fixed_table_condition?.fixed ?? "" }) };
        }
        else if (key === "fixed_table_condition") {
            updatedValues.fixed_table_condition = { ...normalizeFixedTableCondition(data?.fixed_table_condition), ...value };
            if ("fc_rate" in (value || {}) || "fh_rate" in (value || {})) {
                setError((prev) => ({ ...prev, fixed_table_condition: { ...prev?.fixed_table_condition, fc_rate: "", fh_rate: "" } }));
            }
        }
        else if (key === "interval") {
            updatedValues.is_prorated = "true"
            updatedValues.amount = null
            if (value?.value === 1) {
                updatedValues.max_cap_applicable = false;
                updatedValues.max_cap_amount = "";
            }
        }

        else if (key === "is_advanced") {
            updatedValues.is_arrears = false;
            if (value && isEdit) {
                updatedValues.rental_type = updatedRentalData?.rental_type;
                updatedValues.account_type = updatedRentalData?.account_type;
                updatedValues.major_assembly = updatedRentalData?.major_assembly;
                updatedValues.interval = updatedRentalData?.interval;
            } else {
                updatedValues.rental_type = null;
                updatedValues.account_type = null;
                updatedValues.major_assembly = null;
                updatedValues.interval = null;
            }
        }
          if (key === "is_advanced") {
            updatedValues.is_arrears = false
            updatedValues.rental_type = isEdit && updatedRentalData?.is_advanced === value ? updatedRentalData?.rental_type : null;
            updatedValues.account_type = isEdit && updatedRentalData?.is_advanced === value ? updatedRentalData?.account_type : null;
            updatedValues.major_assembly = isEdit && updatedRentalData?.is_advanced === value ? updatedRentalData?.major_assembly : null;
            updatedValues.interval = isEdit && updatedRentalData?.is_advanced === value ? updatedRentalData?.interval : null
            updatedValues.rental_rate_based_on = null;
            updatedValues.unit_of_measurement = null;
            updatedValues.interval_condition = [];
            updatedValues.pbh_conditions = [];
        }
        else if (key === "is_arrears" ) {
            updatedValues.is_advanced = false
            updatedValues.rental_type = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.rental_type : null;
            updatedValues.account_type = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.account_type : null;
            updatedValues.major_assembly = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.major_assembly : null;
            updatedValues.interval_condition = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.interval_condition : [];
            updatedValues.pbh_conditions = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.pbh_conditions : [];
            updatedValues.rental_rate_based_on = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.rental_rate_based_on : null;
            updatedValues.unit_of_measurement = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.unit_of_measurement : null;
            updatedValues.interval = updatedRentalData?.is_arrears === value && isEdit ? updatedRentalData?.interval : null;

        }
        else if (key === "qb_class_id") {
            updatedValues.qb_sub_class_id = null;
        }
        else if (key === "is_interpolation") {
            const fieldMatch = updatedRentalData?.account_type?.value === data?.account_type?.value && updatedRentalData?.major_assembly?.asset_slug === data?.major_assembly?.asset_slug && updatedRentalData?.rental_type?.value === data?.rental_type?.value && data?.rental_rate_based_on?.value === updatedRentalData?.rental_rate_based_on?.value
            updatedValues.interpolation_option = isEdit && value ===  updatedRentalData?.is_interpolation && fieldMatch ? updatedRentalData?.interpolation_option : null
        }
        else if (key === "is_extrapolation") {
            const fieldMatch = updatedRentalData?.account_type?.value === data?.account_type?.value && updatedRentalData?.major_assembly?.asset_slug === data?.major_assembly?.asset_slug && updatedRentalData?.rental_type?.value === data?.rental_type?.value && data?.rental_rate_based_on?.value === updatedRentalData?.rental_rate_based_on?.value
            updatedValues.extrapolation_option = isEdit &&value === updatedRentalData?.is_extrapolation && fieldMatch ? updatedRentalData?.extrapolation_option : null
        }
        else if (key === "table_based_esc") {
            updatedValues.escalation_percentage = isEdit && value === updatedRentalData?.table_based_esc ? updatedRentalData?.escalation_percentage : ""
            updatedValues.escalation_start_date = isEdit && value === updatedRentalData?.table_based_esc ? updatedRentalData?.escalation_start_date : null
            // updatedValues.round_off_escalation = isEdit && value === updatedRentalData?.table_based_esc ? updatedRentalData?.round_off_escalation : null
            prepareEscalationConditions(data?.rental_type?.value === 4 && data?.rental_rate_based_on?.value === 8 ? "interval_condition" : "pbh_conditions", updatedValues, value)
            setPbhErrors({})
        }
        else if (key === "is_prorated") {
            updatedValues.days = isEdit && (updatedRentalData?.is_prorated === "true" || updatedRentalData?.is_prorated === true) ? updatedRentalData?.days : "";
        }
        else if (key === "max_cap_applicable") {
            updatedValues.max_cap_amount = isEdit && updatedRentalData?.max_cap_applicable === value ? updatedRentalData?.max_cap_amount : 0;
        }
        else if (key === "is_base_reading") {
            updatedValues.base_ratio = null; updatedValues.base_derate = null; updatedValues.base_rate = null
        }
        else if (key === "allow_decimal") {
            updatedValues.is_base_reading = false
        }
        else if (key === "currency") {
            updatedValues.amount = null
        }
        // const newState = { ...data, ...updatedValues };
        // const newRoudingCondition =
        //     newState?.rental_type?.value === 1 ||
        //     (newState?.rental_type?.value === 3 &&
        //         newState?.unit_of_measurement?.value &&
        //         !newState?.table_based_esc &&
        //         (newState?.unit_of_measurement?.value !== 4 || !newState?.is_pbh_fixed_table)) ||
        //     (newState?.rental_type?.value === 4 &&
        //         newState?.rental_rate_based_on?.value &&
        //         !(newState?.rental_rate_based_on?.value === 8 && newState?.table_based_esc));
        // if (!newRoudingCondition) {
        //     updatedValues.round_off_escalation = null;
        // }
        setError({})
        setPbhErrors({})
        setData((prev) => ({ ...prev, ...updatedValues, }));
        if (key === 'allow_decimal') {
            onMultiFieldChange('', '', '', '', 'allow_decimal')
        }
    };
    const onAddEditRentalRates = () => {
        let validationInputs = {};
        let hasMultiError = { isValid: true }
        validationInputs = {
            ...validationInputs,
            name: !data?.name ? 'Please enter Rental Name' : '',
            currency: data?.currency ? '' : 'Please select Rental Currency',
            rental_type: data?.rental_type ? '' : 'Please select Rental Type',
            // account_type: data?.account_type ? '' : 'Please select Account Type',
            major_assembly: data?.major_assembly ? '' : 'Please select Major Assembly',
            qb_product_and_service_id: isQbEnabled && !data?.qb_product_and_service_id ? 'Please select Product & Service' : '',
            qb_chart_of_account_id: isQbEnabled && !data?.qb_chart_of_account_id ? 'Please select Chart of Account' : '',
            qb_class_id: isQbEnabled && hanwahaInstance && !data?.qb_class_id ? 'Please select Class' : '',
            qb_sub_class_id: isQbEnabled && hanwahaInstance && !data?.qb_sub_class_id ? 'Please select Sub Class' : '',
            amount: (data?.rental_type?.value == 1 || (data?.rental_type?.value === 3 && data?.fixed_rate)) && !data?.amount ? 'Please enter Rate/Unit' : '',
            start_date: data?.start_date ? '' : 'Please select Start Date',
            end_date: data?.end_date || [5, 3].includes(leaseBasicDetails?.lease_duration_type?.value) ? '' : 'Please select End Date',
            interval: data?.rental_type?.value === 1 || (data?.rental_type?.value === 4 && [8, 9, 10, 11].includes(data?.rental_rate_based_on?.value)) ? (data?.interval ? '' : 'Please select Rental Rate Interval') : '',
            unit_of_measurement: data?.rental_type?.value === 3 ? (data?.unit_of_measurement ? '' : 'Please select Rental Rate Based On') : '',
            rental_rate_based_on: data?.rental_type?.value === 4 ? (data?.rental_rate_based_on ? '' : 'Please select Rental Rate Based On') : '',
            escalation_percentage: data?.table_based_esc || data?.escalation_percentage ? "" : (data?.escalation_interval !== null || data?.escalation_start_date !== null) ? "Please enter Rental Rate Escalation" : data?.escalation_percentage > 100 ? "Rental Rate Escalation must be below 100%" : "",
            escalation_start_date: data?.table_based_esc || data?.escalation_start_date ? "" : (data?.escalation_percentage !== "" || data?.escalation_interval !== null) ? "Please enter Escalation Start Date" : moment(data.escalation_start_date).isBefore(moment(data.start_date)) ? "Escalation Start Date must be after Start Date" : moment(data.escalation_start_date).isAfter(moment(data.end_date)) ? "Escalation Start Date must be before End Date" : data?.escalation_start_date && !isValidYearRange(data?.escalation_start_date) ? "Year must be between 1900 and 2100." : "",
            escalation_interval: data?.table_based_esc || data?.escalation_interval ? "" : (data?.escalation_percentage !== "" || data?.escalation_start_date !== null) ? "Please enter Escalation Interval" : "",
            max_cap_amount: data?.max_cap_applicable ? (data?.max_cap_amount ? '' : 'Please enter Max Cap Amount') : '',
            margin: data?.is_additional_rate ? (data?.margin ? data?.margin > 100 ? 'Dollar Margin (%) must be below 100%' : '' : 'Please enter Dollar Margin') : '',
            days: data?.rental_type?.value === 1 && data?.interval?.value === 1 && (data?.is_prorated === "true" || data?.is_prorated === true) && !data?.days ? "Please enter Number of Day's" : data?.days && (data?.days < 28 || data?.days > 31) ? "Please enter Number of Day's between 28 to 31." : "",
            allow_decimal: ([8,9, 10, 11].includes(data?.rental_rate_based_on?.value)) ? data?.allow_decimal ? "" : "Please select Allow Decimal" : "",
            rounding: ([8,9, 11].includes(data?.rental_rate_based_on?.value)) ? data?.rounding ? "" : "Please select Rounding" : '',
            base_ratio: data?.is_base_reading && ([9, 11].includes(data?.rental_rate_based_on?.value)) ? (data?.base_ratio ? "" : "Please enter Base Ratio") : "",
            base_derate: data?.is_base_reading && ([10, 11].includes(data?.rental_rate_based_on?.value)) ? (data?.base_derate ? "" : "Please enter Base Derate") : "",
            base_rate: data?.is_base_reading ? (data?.base_rate ? "" : "Please enter Base Rate") : "",
            is_advanced: (!data?.is_advanced && !data?.is_arrears) ? "Please select Advanced or Arrears Checkbox" : ""
        };
        const startDate = moment(data?.start_date);
        const endDate = moment(data?.end_date);
        if (data?.start_date && data?.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before Start Date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after End Date";
            }
            if (startDate.isBefore(leaseBasicDetails?.contractual_start_date)) {
                validationInputs.start_date = `Start date cannot be before contract start date ${moment(leaseBasicDetails?.contractual_start_date)?.format(fieldDateFormat) ?? ""}`;
            }
            if (startDate.isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.start_date = "Start date cannot be after lease end date";
            }
            if (endDate.isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.end_date = "End date cannot be after lease end date";
            }
            if (endDate.isBefore(leaseBasicDetails?.contractual_start_date)) {
                validationInputs.end_date = `End date cannot be before contract start date ${moment(leaseBasicDetails?.contractual_start_date)?.format(fieldDateFormat) ?? ""}`;
            }
        }

        if (data?.start_date && data?.end_date && data.escalation_start_date) {
            if (moment(data.escalation_start_date).isBefore(startDate)) {
                validationInputs.escalation_start_date = "Escalation Start Date should be b/w Start date & End date";
            }
            if (moment(data?.escalation_start_date).isAfter(endDate)) {
                validationInputs.escalation_start_date = "Escalation Start Date should be b/w Start date & End date";
            }
        }
        let customPaymentErrors = [];

        if (data?.rental_type?.value === 2) {
            if (!Array.isArray(data?.custom_payments) || data.custom_payments.length === 0) {
                validationInputs.custom_payments = "Please add at least one payment row";
                enqueueSnackbar('Please add custom payment schedule data using sample file', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            } else {
                data.custom_payments.forEach((row, index) => {
                    const rowErrors = {};
                    if (row.period === '' || row.period === null || row.period === undefined) {
                        rowErrors.period = "Please enter Calculation Period";
                    }
                    if (!row.payment_date || !moment(row.payment_date).isValid()) {
                        rowErrors.payment_date = "Enter valid Payment Date";
                    }
                    if (row.rent === '' || row.rent === null || row.rent === undefined) {
                        rowErrors.rent = "Please enter the Rent";
                    }
                    if (row.reference_value === '' || row.reference_value === null || row.reference_value === undefined) {
                        rowErrors.reference_value = "Please enter Reference Value";
                    }
                    if (row.basic_rent === '' || row.basic_rent === null || row.basic_rent === undefined) {
                        rowErrors.basic_rent = "Please enter Basic Rent";
                    }
                    if (
                        !moment(row.payment_date).isBetween(
                            data.start_date,
                            data.end_date,
                            undefined,
                            '[]'
                        )
                    ) {
                        rowErrors.payment_date = `Payment date must be between ${moment(data.start_date).format(fieldDateFormat)} and ${moment(data.end_date).format(fieldDateFormat)}`;
                    }
                    if (Object.keys(rowErrors).length > 0) {
                        customPaymentErrors[index] = rowErrors;
                    }
                });
            }
        }
        if (data?.is_pbh_fixed_table) {
            const fixedTableCondition = data?.fixed_table_condition || {};
            const isDailyRentEnabled = data?.daily_rent === true;
            validationInputs.fixed_table_condition = {
                ...(isDailyRentEnabled
                    ? { daily: fixedTableCondition?.daily === "" || fixedTableCondition?.daily === null || fixedTableCondition?.daily === undefined ? "Please enter Daily Rate" : Number(fixedTableCondition?.daily) > 0 ? "" : "Daily Rate should be greater than 0" }
                    : { fixed: fixedTableCondition?.fixed === "" || fixedTableCondition?.fixed === null || fixedTableCondition?.fixed === undefined ? "Please enter Fixed Rate" : Number(fixedTableCondition?.fixed) > 0 ? "" : "Fixed should be greater than 0" }),
                fc_rate: fixedTableCondition?.fh_rate && Number(fixedTableCondition?.fh_rate) > 0 ? "" : fixedTableCondition?.fc_rate === "" || fixedTableCondition?.fc_rate === null || fixedTableCondition?.fc_rate === undefined ? "Please enter either FC or FH" : Number(fixedTableCondition?.fc_rate) > 0 ? "" : "FC Rate should be greater than 0",
                fh_rate: fixedTableCondition?.fc_rate && Number(fixedTableCondition?.fc_rate) > 0 ? "" : fixedTableCondition?.fh_rate === "" || fixedTableCondition?.fh_rate === null || fixedTableCondition?.fh_rate === undefined ? "Please enter either FH or FC" : Number(fixedTableCondition?.fh_rate) > 0 ? "" : "FH Rate should be greater than 0",
            };
        }
        if (((data?.rental_type?.value === 3 && data?.unit_of_measurement) || (data?.rental_type?.value === 4 && data?.rental_rate_based_on?.value === 8) && data?.interval) && !data?.is_pbh_fixed_table && !data?.fixed_rate) {
            const key = data?.rental_type?.value === 3 && data?.unit_of_measurement ? "pbh_conditions" : "interval_condition";
            hasMultiError = { isValid: checkRangeConditionsValiadation(data, key, setPbhErrors) }
        }

        // ----------------Ratio Condition-----------
        if ([9, 10, 11].includes(data?.rental_rate_based_on?.value)) { hasMultiError = checkRatioValidation(data && data?.interval_condition, data?.rental_rate_based_on) }
        const isValidationClear = Object.keys(validationInputs).every((k) => {
            const fieldValue = validationInputs[k];
            if (fieldValue && typeof fieldValue === "object" && !Array.isArray(fieldValue)) {
                return Object.values(fieldValue).every((value) => value === "");
            }
            return fieldValue === "";
        });
        if (isValidationClear && (data?.rental_type?.value !== 2 || customPaymentErrors.length === 0) && hasMultiError?.isValid) {
            setLoading(true);
            let payload
            const hasFixedTable = data?.is_pbh_fixed_table === true;
            const isFixedRateMode = data?.rental_type?.value === 3 && data?.fixed_rate === true;
            const isDailyRentEnabled = hasFixedTable && data?.daily_rent === true;
            const fixedTableCondition = hasFixedTable ? {
                fixed: isDailyRentEnabled || data?.fixed_table_condition?.fixed === "" || data?.fixed_table_condition?.fixed === null || data?.fixed_table_condition?.fixed === undefined ? null : Number(data?.fixed_table_condition?.fixed),
                daily: !isDailyRentEnabled || data?.fixed_table_condition?.daily === "" || data?.fixed_table_condition?.daily === null || data?.fixed_table_condition?.daily === undefined ? null : Number(data?.fixed_table_condition?.daily),
                fc_rate: data?.fixed_table_condition?.fc_rate === "" || data?.fixed_table_condition?.fc_rate === null || data?.fixed_table_condition?.fc_rate === undefined ? null : Number(data?.fixed_table_condition?.fc_rate),
                fh_rate: data?.fixed_table_condition?.fh_rate === "" || data?.fixed_table_condition?.fh_rate === null || data?.fixed_table_condition?.fh_rate === undefined ? null : Number(data?.fixed_table_condition?.fh_rate),
            } : null;
            const updatedPayload = {
                ...data,
                interval: (data?.rental_type?.value === 1) || (data?.rental_type?.value === 4 && [8, 9, 10, 11].includes(data?.rental_rate_based_on?.value)) ? data?.interval : null,
                amount: data?.rental_type?.value === 1 ? data?.amount : isFixedRateMode ? data?.amount : null,
                unit_of_measurement: data?.rental_type?.value === 3 ? data?.unit_of_measurement : null,
                escalation_start_date: data.escalation_start_date ? data.escalation_start_date : null,
                escalation_percentage: data.escalation_percentage ? data.escalation_percentage : null,
                /* round_off_escalation: (
                    data?.rental_type?.value === 1 ||
                    (data?.rental_type?.value === 3 &&
                        data?.unit_of_measurement?.value &&
                        !data?.table_based_esc &&
                        (data?.unit_of_measurement?.value !== 4 || !data?.is_pbh_fixed_table)) ||
                    (data?.rental_type?.value === 4 &&
                        data?.rental_rate_based_on?.value &&
                        !(data?.rental_rate_based_on?.value === 8 && data?.table_based_esc))
                ) ? data?.round_off_escalation : null, */
                is_additional_rate: data.is_additional_rate === true ? true : false,
                max_cap_applicable: data.max_cap_applicable === true ? true : false,
                margin: data.margin ? data.margin : null,
                currency: data?.currency ? data?.currency?.code : null,
                max_cap_amount: data.max_cap_amount ? data.max_cap_amount : null,
                account_type: data.account_type ? data.account_type : null,
                qb_product_and_service_id: data?.qb_product_and_service_id ? data?.qb_product_and_service_id : null,
                qb_chart_of_account_id: data?.qb_chart_of_account_id ? data?.qb_chart_of_account_id : null,
                qb_class_id: data?.qb_class_id ? data?.qb_class_id : null,
                qb_sub_class_id: data?.qb_sub_class_id ? data?.qb_sub_class_id : null,
                major_assembly: { asset_type: Number(data?.major_assembly?.asset_type), asset_id: Number(data?.major_assembly?.asset_id || data?.major_assembly?.id), name: data?.major_assembly?.asset_name || data?.major_assembly?.name },
                range_condition_to_consider: data?.rental_type?.value === 3 ? data?.range_condition_to_consider ? data?.range_condition_to_consider : "either_off" : null,
                days: data?.rental_type?.value === 1 && data?.interval?.value === 1 && (data?.is_prorated === "true" || data?.is_prorated === true) ? Number(data?.days) : 0,
                is_advanced: data?.is_advanced ? data?.is_advanced : false,
                is_arrears: data?.is_arrears ? data?.is_arrears : false,
                is_interpolation: data?.rental_type?.value === 4 && data?.interpolation_option && [1].includes( Number(data?.interpolation_option)) ? true : false,
                is_extrapolation: data?.rental_type?.value === 4 && data?.extrapolation_option && [1,3].includes(Number(data?.extrapolation_option)) ? true : false,
                interpolation_option: data?.rental_type?.value === 4 && data?.interpolation_option ? Number(data?.interpolation_option) : null,
                extrapolation_option: data?.rental_type?.value === 4 && data?.extrapolation_option ? Number(data?.extrapolation_option) : null,
                allow_decimal: ([8,9, 10, 11].includes(data?.rental_rate_based_on?.value)) ? data?.allow_decimal?.value : null,
                rounding: ([8,9, 11].includes(data?.rental_rate_based_on?.value)) ? data?.rounding?.value : null,
                custom_payments: data?.rental_type?.value === 2 ? data?.custom_payments?.map((row) => ({
                    ...row,
                    period: row.period === '' || row.period === null || row.period === undefined ? row.period : Number(row.period),
                    rent: row.rent === '' || row.rent === null || row.rent === undefined ? row.rent : Number(row.rent),
                    basic_rent: row.basic_rent === '' || row.basic_rent === null || row.basic_rent === undefined ? row.basic_rent : Number(row.basic_rent),
                    reference_value: row.reference_value === '' || row.reference_value === null || row.reference_value === undefined ? row.reference_value : Number(row.reference_value),
                })) : data?.custom_payments,
                pbh_conditions: data?.rental_type?.value === 3 && !hasFixedTable && !isFixedRateMode ? data?.pbh_conditions : [],
                fixed_rate: data?.rental_type?.value === 3 ? isFixedRateMode : false,
                ...(hasFixedTable ? { is_pbh_fixed_table: true, fixed_table_condition: fixedTableCondition, daily_rent: isDailyRentEnabled } : {}),
            };
            if (!hasFixedTable) {
                delete updatedPayload.is_pbh_fixed_table;
                delete updatedPayload.fixed_table_condition;
                delete updatedPayload.daily_rent;
            }
            if (data?.rental_type?.value === 1 && data?.interval?.value === 1) {
                payload = {
                    ...updatedPayload,
                    is_prorated: data?.interval?.value === 1 ? data?.is_prorated == "true" || data?.is_prorated == true ? true : false : null,
                }
            } else {
                delete updatedPayload?.is_prorated
                payload = updatedPayload
            }
            if (data.id) {
                globalPutService(updateRentalRateApi({ ...params, slug: data?.slug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Rental Rate`, success_msg: response?.data?.message, item_id: payload?.id, payload: payload, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Rental Rate`, error_msg: response?.data?.message, item_id: payload?.id, payload: payload, response: response?.data })
                    }
                });
            } else {
                globalPostService(addRentalRateApi(params), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Rental Rate`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Rental Rate`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError({ ...validationInputs, custom_payments: customPaymentErrors,...hasMultiError.errors});
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Rental Rate`, error_msg: validationInputs, })
        }
    };
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
    const onRestCustomPaymentFieldError = (rowIndex, fieldKey) => {
        const updatedCustomErrors = [...(error?.custom_payments || [])];
        if (updatedCustomErrors[rowIndex]) {
            updatedCustomErrors[rowIndex][fieldKey] = '';
        }
        setError({ ...error, custom_payments: updatedCustomErrors });
    };
    const resetPBHError = (rowIndex, fieldName) => {
        setPbhErrors((prevErrors) => {
            const rowErrors = { ...prevErrors[rowIndex] };
            delete rowErrors[fieldName];

            const updatedErrors = { ...prevErrors };
            if (Object.keys(rowErrors).length === 0) {
                delete updatedErrors[rowIndex];
            } else {
                updatedErrors[rowIndex] = rowErrors;
            }

            return updatedErrors;
        });
    };
    const onAddMultiRow = (rangeCondition) => {
        const rangeConditionErrors = {};
        const rangeConditionFields = [];
        if (!data?.interval) {
            rangeConditionErrors.interval = "Please select Rental Rate interval";
            rangeConditionFields.push("Rental Rate Interval");
        }
        if (!data?.allow_decimal ) {
            rangeConditionErrors.allow_decimal = "Please select Allow Decimal";
            rangeConditionFields.push("Allow Decimal");
        }
        if (!data?.rounding && [8,9, 11].includes(rangeCondition)) {
            rangeConditionErrors.rounding = "Please select Rounding";
            rangeConditionFields.push("Rounding");
        }
        if (rangeConditionFields.length > 0 && data?.rental_type?.value === 4) {
            const fieldList = rangeConditionFields.length < 3 ? rangeConditionFields.join(' and ') : `${rangeConditionFields.slice(0, -1).join(', ')} and ${rangeConditionFields.at(-1)}`;
            enqueueSnackbar(`Please select ${fieldList} field(s).`, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            setError(prev => ({ ...prev, ...rangeConditionErrors }));
            return;
        }

        const addObject = { rate: 0, type: rangeCondition, ...(rangeCondition === 9 ? { ratio: 0 } : { derate: 0 }) };
        setData(prev => ({ ...prev, interval_condition: [...prev.interval_condition, addObject] }));
    };
    const onMultiFieldChange = (arrKey, rowIndex, field, value, allowKey) => {
        if (allowKey) {
            const newData = data?.interval_condition?.map(row => ({
                ...row, ratio: 0, rate: 0, derate: 0,
                ratios: row?.ratios?.map(r =>
                    ({ ...r, rate: 0 })
                )
            }));
            setData(prev => ({ ...prev, ["interval_condition"]: newData }));
        } else {
            const updatedArray = (data && arrKey && [...data[arrKey]]) || [];
            const newData = updatedArray.map((row, index) => {
                if (index === rowIndex) { return { ...row, [field]: value }; }
                return row;
            });
            setData((prev) => ({ ...prev, [arrKey]: newData }));
        }
    };
    const onMultiDelete = (arrKey, rowIndex) => { setData((prev) => ({ ...prev, [arrKey]: prev[arrKey]?.filter((_, index) => index !== rowIndex), })); }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Rental Rates`, page_type: page_type, })
    }
    let updatedRentalType = []
    if (data?.is_advanced) { updatedRentalType = pltConstants?.constant_types?.filter(item => item.type === 'rental_type')?.filter(ele => ele.value === 1 || ele.value === 2) }
    else if (data?.is_arrears) { updatedRentalType = pltConstants?.constant_types?.filter(item => item.type === 'rental_type')?.filter(ele => ele.value !== 2) }
    const onImportExcel = () => {
        if (!excelData?.length) return;
        const key = [8,9, 10].includes(data?.rental_rate_based_on?.value) ? "interval_condition" : "pbh_conditions";
        const currentType = excelData[0]?.unit_of_measure_for?.value;
        setData((prev) => {
          const existing = prev[key] || [];
          const filtered = existing.filter( (item) => item?.unit_of_measure_for?.value !== currentType );
          return { ...prev, [key]: [...filtered, ...excelData], };
        });
      };
    // const roudingCondition =
    //     data?.rental_type?.value === 1 ||
    //     (data?.rental_type?.value === 3 &&
    //         data?.unit_of_measurement?.value &&
    //         !data?.table_based_esc &&
    //         (data?.unit_of_measurement?.value !== 4 || !data?.is_pbh_fixed_table)) ||
    //     (data?.rental_type?.value === 4 &&
    //         data?.rental_rate_based_on?.value &&
    //         !(data?.rental_rate_based_on?.value === 8 && data?.table_based_esc));
       return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='lg'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="customized-dialog-title">
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Rental Rates" : modeType === 'edit' ? 'Edit Rental Rates' : 'View Rental Rates '}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} >
                        <Box sx={{ width: '100%' }} className="escalation-container" >
                            <Typography className='section-header-text'><u>Advanced and Arrears Details *:</u></Typography>
                            <AdvanceArrearsDetails advanceData={data} onFieldChange={onFieldChange} modeType={modeType} error={error} onFocusChange={onRestErrorKey} />
                        </Box>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={data?.name?.length > 23 ? data?.name : ""} placement="bottom" arrow>
                                <TextField
                                    required
                                    id="name"
                                    value={data?.name ? data?.name : ''}
                                    onChange={(e, value) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('name', e.target.value.trimStart()) : e.preventDefault() }}
                                    label="Rental Name"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    error={!!error.name}
                                    helperText={error.name}
                                    onFocus={() => onRestErrorKey("name")}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                    fullWidth
                                    disabled={modeType === 'view'}
                                />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={updatedRentalType}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.label || ""}
                                noOptionsText={modeType !== "view" && dropDownloader?.constantType ? "Loading..." : "No Option Available"}
                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                value={pltConstants?.constant_types?.find(item => item.type === 'rental_type' && item?.value === data?.rental_type?.value) || null}
                                onChange={(e, value) => { onFieldChange("rental_type", value) }}
                                onFocus={() => onRestErrorKey("rental_type")}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField required {...params} label="Rental Type" margin='normal' size='small' error={Boolean(error.rental_type)} helperText={error.rental_type} slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownloader?.constantType && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </>) } }}
                                            disabled={modeType === 'view'} /></Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Start Date"
                                    value={data?.start_date ? moment(data.start_date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        const formattedDate = isValid ? moment(value).format(backendDateFormat) : null;
                                        onFieldChange("start_date", formattedDate);
                                        if (isValid) {
                                            onRestErrorKey("start_date");
                                            if (data?.end_date && !moment(formattedDate).isAfter(moment(data.end_date))) {
                                                setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                            }
                                        }
                                    }}

                                    slotProps={{
                                        textField: {
                                            required: "true",
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.start_date || false,
                                            helperText: error.start_date || '',
                                            onFocus: () => {
                                                if (error.start_date) {
                                                    onRestErrorKey("start_date");
                                                }
                                            }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("start_date", null);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="End Date"
                                    value={data?.end_date ? moment(data.end_date) : null}
                                    onChange={(value) => {
                                        const isValid = moment(value)?.isValid();
                                        const formattedDate = isValid ? moment(value).format(backendDateFormat) : null;
                                        onFieldChange("end_date", formattedDate);
                                        if (isValid) {
                                            onRestErrorKey("end_date");
                                            if (data?.start_date && !moment(formattedDate).isBefore(moment(data.start_date))) {
                                                setError(prev => ({ ...prev, start_date: "", end_date: "" }));
                                            }
                                        }
                                    }}
                                    minDate={data?.start_date ? moment(data.start_date) : null}
                                    slotProps={{
                                        textField: {
                                            required: ![5, 3].includes(leaseBasicDetails?.lease_duration_type?.value),
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.end_date || false,
                                            helperText: error.end_date || '',
                                            onFocus: () => {
                                                if (error.end_date) {
                                                    onRestErrorKey("end_date");
                                                }
                                            }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("end_date", null);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                options={pltConstants?.rate_account_types || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option?.name || option?.label || ""}
                                noOptionsText={modeType !== "view" && dropDownloader?.rateAccountType ? "Loading..." : <Link onClick={() => navigate(`/settings/rate-account-type`)} sx={{ textDecoration: "none", cursor: "pointer" }} >+ Add New Account Type</Link>}
                                value={data?.account_type || null}
                                onFocus={() => onRestErrorKey("account_type")}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.name === value?.name}
                                onChange={(e, value) => { onFieldChange("account_type", value); }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField {...params} label="Account Type" margin='normal' size='small' error={Boolean(error.account_type)} helperText={error.account_type}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownloader?.rateAccountType && <CircularProgress size={20} />} {params?.InputProps?.endAdornment} </>) } }}
                                            disabled={modeType === 'view'} /> </Tooltip>)
                                }}
                            />
                        </Grid>
                        {isQbEnabled && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={productServices}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.productService ? "Loading..." : "No Options Available"}
                                    value={data?.qb_product_and_service_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_product_and_service_id", value || null); setError(prev => ({ ...prev, qb_product_and_service_id: '' })) }}
                                    disabled={modeType === 'view'}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Product & Service"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_product_and_service_id)}
                                            helperText={error.qb_product_and_service_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.productService ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view'}
                                        />
                                    )}
                                />
                                {isQbEnabled && <Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by:{" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {productServices[0]?.qb_last_sync_by?.name ? `${productServices[0]?.qb_last_sync_by.name} (${productServices[0]?.last_synced_at ? moment(productServices[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>}
                            </Grid>
                        )}
                        {isQbEnabled && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={chartOfAccounts}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.chartOfAccount ? "Loading..." : "No Options Available"}
                                    value={data?.qb_chart_of_account_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_chart_of_account_id", value || null); setError(prev => ({ ...prev, qb_chart_of_account_id: '' })) }}
                                    disabled={modeType === 'view'}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Chart of Account"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_chart_of_account_id)}
                                            helperText={error.qb_chart_of_account_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.chartOfAccount ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view'}
                                        />
                                    )}
                                />
                                {isQbEnabled && <Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by:{" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {chartOfAccounts[0]?.qb_last_sync_by?.name ? `${chartOfAccounts[0]?.qb_last_sync_by.name} (${chartOfAccounts[0]?.last_synced_at ? moment(chartOfAccounts[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>}
                            </Grid>
                        )}
                        {isQbEnabled && hanwahaInstance && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={classes}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.class ? "Loading..." : "No Options Available"}
                                    value={data?.qb_class_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_class_id", value || null); setError(prev => ({ ...prev, qb_class_id: '' })) }}
                                    disabled={modeType === 'view'}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Class"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_class_id)}
                                            helperText={error.qb_class_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.class ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view'}
                                        />
                                    )}
                                />
                                {isQbEnabled && <Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by:{" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {classes[0]?.qb_last_sync_by?.name ? `${classes[0]?.qb_last_sync_by.name} (${classes[0]?.last_synced_at ? moment(classes[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>}
                            </Grid>
                        )}
                        {isQbEnabled && hanwahaInstance && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={subClasses}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.subClass ? "Loading..." : "No Options Available"}
                                    value={data?.qb_sub_class_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_sub_class_id", value || null); setError(prev => ({ ...prev, qb_sub_class_id: '' })) }}
                                    disabled={modeType === 'view' || !data?.qb_class_id}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Sub Class"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_sub_class_id)}
                                            helperText={error.qb_sub_class_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.subClass ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view' || !data?.qb_class_id}
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={pltConstants?.asset_types || []}
                                disabled={modeType === 'view' || dropDownloader?.majorAssembly}
                                getOptionLabel={(option) => option.name || ""}
                                noOptionsText={modeType !== "view" && dropDownloader?.majorAssembly ? "Loading..." : "No Option Available"}
                                value={data?.major_assembly || null}
                                onFocus={() => onRestErrorKey("major_assembly")}
                                isOptionEqualToValue={(option, value) => option?.id === (value.id ? value.id : value?.asset_id)}
                                onChange={(e, value) => onFieldChange("major_assembly", value)}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField {...params} required label="Major Assembly" margin='normal' size='small' error={Boolean(error.major_assembly)} helperText={error.major_assembly}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownloader?.majorAssembly && (<CircularProgress color="inherit" size={20} />)} {params?.InputProps?.endAdornment} </>) } }}
                                            disabled={modeType === 'view' || dropDownloader?.majorAssembly}
                                        /></Tooltip>)
                                }}
                            />
                        </Grid>
                        {data?.rental_type?.value === 3 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    options={data?.major_assembly ? pltConstants?.constant_types?.filter(constant => constant.type === 'unit_of_measure')?.filter(interval =>
                                        data?.major_assembly?.asset_type === 1 ?
                                            [1, 2, 3, 4]?.includes(interval?.value)
                                            : [1, 2, 4]?.includes(interval?.value)
                                    )
                                        || [] : []}
                                    disabled={modeType === 'view'}
                                    getOptionLabel={(option) => option.label || ""}
                                    noOptionsText={dropDownloader?.constantType ? "Loading..." : "No Option Available"}
                                    value={data?.unit_of_measurement || null}
                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                    onChange={(e, value) => { onFieldChange("unit_of_measurement", value); }}
                                    onFocus={() => onRestErrorKey("unit_of_measurement")}
                                    renderInput={(params) => (<TextField required={data?.rental_type?.value === 3} {...params} label="Rental Rate Based On" margin='normal' size='small' error={Boolean(error.unit_of_measurement)} helperText={error.unit_of_measurement}
                                        slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{dropDownloader?.constantType ? (<CircularProgress color="inherit" size={20} />) : null} {params?.InputProps?.endAdornment} </>) } }}
                                        disabled={modeType === 'view'} />)}
                                />
                            </Grid> : null}
                        {data?.rental_type?.value === 1 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    options={data?.major_assembly ? pltConstants?.constant_types?.filter(constant => constant.type === 'interval')?.filter(interval =>
                                        data?.is_advanced ? [1, 5,]?.includes(interval?.value) :
                                            data?.major_assembly?.asset_type === 1 ?
                                                [1, 2, 3, 5, 6]?.includes(interval?.value)
                                                : [1, 2, 3, 5,]?.includes(interval?.value)
                                    )
                                        || [] : []}
                                    disabled={modeType === 'view'}
                                    noOptionsText={dropDownloader?.constantType ? "Loading..." : "No Option Available"}
                                    getOptionLabel={(option) => option.label || ""}
                                    value={data?.interval || null}
                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                    onChange={(e, value) => { onFieldChange("interval", value); }}
                                    onFocus={() => onRestErrorKey("interval")}
                                    renderInput={(params) => (<TextField required={data?.rental_type?.value === 1} {...params} label="Interval" margin='normal' size='small' error={Boolean(error.interval)} helperText={error.interval}
                                        slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{dropDownloader?.constantType ? (<CircularProgress color="inherit" size={20} />) : null} {params?.InputProps?.endAdornment} </>) } }}
                                        disabled={modeType === 'view'} />)}
                                />
                            </Grid> : null}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={pltConstants?.currencies || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.name || ""}
                                value={pltConstants?.currencies?.find(item => item?.code === data?.currency?.code) || null}
                                onChange={(e, value) => onFieldChange("currency", value)}
                                noOptionsText={ modeType !== "view" && dropDownloader?.currency ? "Loading..." : "No Option Available" }
                                onFocus={() => onRestErrorKey("currency")}
                                isOptionEqualToValue={(option, value) => option.code === value.code}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                required
                                                {...params}
                                                label="Rental Currency"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.currency)}
                                                helperText={error.currency}
                                                disabled={modeType === 'view'}
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                    input: {
                                                        ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownloader?.currency && (
                                                            <CircularProgress size={20} />
                                                        )}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                        )
                                                    }
                                                }}
                                            />
                                        </Tooltip>)}}
                            />
                        </Grid>
                        {data?.rental_type?.value === 1 ? <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="amount"
                                value={modeType === 'view' && data?.amount !== '' && data?.amount !== null && data?.amount !== undefined ? numberWithCommas(data?.amount) : (data?.amount ? data?.amount : '')}
                                onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('amount', e.target.value) : e.preventDefault() }}
                                label={`Rate / Unit`}
                                variant="outlined"
                                size="small"
                                margin="normal"
                                error={!!error.amount}
                                helperText={error.amount}
                                onFocus={() => onRestErrorKey("amount")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{data?.currency?.symbol}</InputAdornment>) } }}
                                fullWidth
                                disabled={modeType === 'view'}
                            />
                        </Grid> : null}
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Box className="escalation-container" sx={{ mt: 1 }}>
                            {data?.rental_type?.value === 4 ? <Box className={[8, 9, 10, 11].includes(data?.rental_rate_based_on?.value) ? "range-box-rental" : "range-box-p-12"} >
                                <Grid container spacing={2} sx={{ paddingRight: '12px' }}>
                                    <Grid size={{ md: 3, xs: 12 }}>
                                        <Autocomplete
                                            disablePortal
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            options={data?.major_assembly ? pltConstants?.constant_types?.filter(constant => constant.type === 'interval')?.filter(interval =>
                                                data?.major_assembly?.asset_type === 2 ?
                                                    [8, 9, 10, 11]?.includes(interval?.value)
                                                    : [8, 9]?.includes(interval?.value)
                                            )
                                                || [] : []}
                                            disableClearable
                                            disabled={modeType === 'view'}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={data?.rental_rate_based_on}
                                            onChange={(e, value) => onFieldChange("rental_rate_based_on", value)}
                                            onFocus={() => onRestErrorKey("rental_rate_based_on")}
                                            noOptionsText={ modeType !== "view" && dropDownloader?.constantType ? "Loading..." : "No Option Available" }
                                            renderInput={(params) => {
                                                const selectedLabel = params?.inputProps?.value || "";
                                                return (
                                                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                                        <TextField
                                                            {...params}
                                                            required
                                                            label="Rental Rate Based On"
                                                            margin='normal'
                                                            size='small'
                                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownloader?.constantType && ( <CircularProgress size={20} /> )} {params.InputProps.endAdornment} </> ) } }}
                                                            error={error.rental_rate_based_on}
                                                            helperText={error.rental_rate_based_on}
                                                            disabled={modeType === 'view'}
                                                        />
                                                    </Tooltip>)}}
                                        />
                                    </Grid>
                                    {[8, 9, 10, 11].includes(data?.rental_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                        <Autocomplete
                                            disablePortal
                                            disableClearable
                                            options={pltConstants?.constant_types?.filter(constant => constant?.type === 'interval')?.filter(interval => [2, 3].includes(interval?.value)) || []}
                                            disabled={modeType === 'view'}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={data?.interval || null}
                                            onChange={(e, value) => onFieldChange("interval", value)}
                                            onFocus={() => onRestErrorKey("interval")}
                                            noOptionsText={ modeType !== "view" && dropDownloader?.constantType ? "Loading..." : "No Option Available" }
                                            renderInput={(params) => {
                                                const selectedLabel = params?.inputProps?.value || "";
                                                return (
                                                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                                        <TextField
                                                            required
                                                            {...params}
                                                            label="Rental Rate Interval"
                                                            margin='normal'
                                                            size='small'
                                                            error={Boolean(error.interval)}
                                                            helperText={error.interval}
                                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownloader?.constantType && ( <CircularProgress size={20} /> )} {params.InputProps.endAdornment} </> ) } }}
                                                            disabled={modeType === 'view'}
                                                        />
                                                    </Tooltip>)
                                            }}
                                        />
                                    </Grid> : null}
                                    {[8,9, 10, 11].includes(data?.rental_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                        {(() => {
                                            let options = [{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }, { label: '5', value: 5 }, { label: '6', value: 6 },];
                                            return (
                                                <Autocomplete
                                                    disablePortal
                                                    disableClearable
                                                    options={options}
                                                    disabled={modeType === 'view'}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    getOptionLabel={(option) => option.label || ""}
                                                    value={options.find(opt => opt.value === data?.allow_decimal?.value) || null}
                                                    onChange={(e, value) => onFieldChange("allow_decimal", value)}
                                                    onFocus={() => onRestErrorKey("allow_decimal")}
                                                    noOptionsText="No Option Available"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            required
                                                            {...params}
                                                            label={
                                                                <span style={{ verticalAlign: 'super' }}>
                                                                    Allow Decimal
                                                                    <Tooltip placement='right' title={<span>Specifies the decimal precision to which the FH/FC ratio from utilisation is rounded before matching against the Ratio Table.</span>} arrow>
                                                                        <InfoIcon fontSize='18px' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: '18px' ,cursor:"pointer"}} />
                                                                    </Tooltip>
                                                                </span>
                                                            }
                                                            margin='normal'
                                                            size='small'
                                                            error={Boolean(error.allow_decimal)}
                                                            helperText={error.allow_decimal}
                                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) } }}
                                                            disabled={modeType === 'view'}
                                                        />
                                                    )}
                                                />
                                            )
                                        })()}
                                    </Grid> : null}
                                    {[8,9, 11].includes(data?.rental_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                        {(() => {
                                            let options = [{ label: 'Rounding Up', value: 1 }, { label: 'Rounding Down', value: 2 }, { label: 'Rounding Off', value: 3 },{ label: 'No Rounding', value: 4 }
                                            ];
                                            return (
                                                <Autocomplete
                                                    disablePortal
                                                    disableClearable
                                                    options={options}
                                                    disabled={modeType === 'view'}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    getOptionLabel={(option) => option.label || ""}
                                                    value={data?.rounding || null}
                                                    onChange={(e, value) => onFieldChange("rounding", value)}
                                                    onFocus={() => onRestErrorKey("rounding")}
                                                    noOptionsText="No Option Available"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            required
                                                            {...params}
                                                            label={
                                                                <span style={{ verticalAlign: 'super' }}>
                                                                    Rounding
                                                                    <Tooltip placement='right' title={<span>Determines how the FH/FC ratio is rounded to the selected decimal places — Round Up (ceiling), Round Down (floor/truncate), Round Off (standard), or No Rounding (use raw ratio value).</span>} arrow>
                                                                        <InfoIcon fontSize='18px' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: '18px' ,cursor:"pointer"}} />
                                                                    </Tooltip>
                                                                </span>
                                                            }
                                                            margin='normal'
                                                            size='small'
                                                            error={Boolean(error.rounding)}
                                                            helperText={error.rounding}
                                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) } }}
                                                            disabled={modeType === 'view'}
                                                        />
                                                    )}
                                                />
                                            )
                                        })()}
                                    </Grid> : <Grid size={{ md: 3, xs: 12 }}></Grid>}
                                    {[9, 10, 11].includes((data?.rental_rate_based_on?.value)) ? <Grid item xs={12} md={12}> <InterpolationExtrapolation projectionData={data} modeType={modeType} onFieldChange={onFieldChange} /></Grid> : null}
                                </Grid>
                            </Box> : null}
                            {(data?.rental_type?.value === 3 && data.unit_of_measurement) || [8, 9, 10, 11]?.includes(data?.rental_rate_based_on?.value) ? <Box className="rate-table-wrapper" >
                                {[9, 10].includes(data?.rental_rate_based_on?.value) ?
                                    <CustomRatioDerateTable
                                        ratioDerateData={data}
                                        onMultiFieldChange={onMultiFieldChange}
                                        onMultiDelete={onMultiDelete}
                                        onAddMultiRow={onAddMultiRow}
                                        modeType={modeType}
                                        rateBasedOn={data?.rental_rate_based_on?.value}
                                        error={error}
                                        onFocusChange={onRestErrorKey}
                                        onImportExcel={onImportExcel}
                                        excelData={excelData}
                                        setExcelData={setExcelData}
                                        handleItemClicked={handleItemClicked}
                                    />
                                    : null}
                                {data?.rental_rate_based_on?.value === 11  ?
                                    <DerateBasedRatioTable
                                        ratioDerateData={data}
                                        setRatioDerateData={setData}
                                        modeType={modeType}
                                        page="Rental"
                                        setError={setError}
                                        error={error}
                                        onFocusChange={onRestErrorKey}
                                        handleItemClicked={handleItemClicked}
                                    /> : null}
                                {(data?.rental_type?.value === 3 && data.unit_of_measurement) || data?.rental_rate_based_on?.value === 8 ?
                                    <RangeConditionTable
                                        data={data}
                                        onFieldChange={onFieldChange}
                                        pbhErrors={pbhErrors}
                                        resetPBHError={resetPBHError}
                                        modeType={modeType}
                                        setError={setError}
                                        error={error}
                                        onImportExcel={onImportExcel}
                                        excelData={excelData}
                                        setExcelData={setExcelData}
                                    />
                                    : null}
                            </Box> : null}
                            {[9, 10, 11].includes(data?.rental_rate_based_on?.value) ? <Box className="rate-table-wrapper" sx={{ paddingTop: "0px" }}>
                                <Box marginLeft={-1} sx={{cursor: modeType === "view" ? "not-allowed" : "pointer"}}>
                                    <Checkbox
                                        checked={data?.is_base_reading || false}
                                        onChange={(e) => onFieldChange('is_base_reading', e.target.checked)}
                                        disabled={modeType === 'view'} disableRipple />
                                    <span className="check-item-span" style={{ fontSize: "14px" }}>Enable Base Reading</span>
                                </Box>
                                {data?.is_base_reading ? <Grid container spacing={2} style={{ marginTop: "10px" }} >
                                    {[9, 11].includes(data?.rental_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                        <TextField
                                            required
                                            id="base_ratio}"
                                            value={data?.base_ratio || ''}
                                            onChange={(e) => { regexConstants.decimalNoDotStartWithVariables(data?.allow_decimal?.value).test(e.target.value) ? onFieldChange("base_ratio", e.target.value) : e.preventDefault() }}
                                            label="Base Ratio"
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            error={!!error.base_ratio}
                                            helperText={error.base_ratio}
                                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 } }}
                                            onFocus={() => onRestErrorKey("base_ratio")}
                                            fullWidth
                                            disabled={modeType === 'view'}
                                        />
                                    </Grid> : null}
                                    {[10, 11].includes(data?.rental_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                        <TextField
                                            required
                                            id="base_derate"
                                            value={data?.base_derate || ''}
                                            onChange={(e) => { regexConstants.decimalNoDotStartWithVariables(data?.allow_decimal?.value).test(e.target.value) ? onFieldChange("base_derate", e.target.value) : e.preventDefault() }}
                                            label={`Base Derate${data?.interval?.label ? `/${data?.interval?.label}` : "" }`}
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            error={!!error.base_derate}
                                            helperText={error.base_derate}
                                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 } }}
                                            onFocus={() => onRestErrorKey("base_derate")}
                                            fullWidth
                                            disabled={modeType === 'view'}
                                        />
                                    </Grid> : null}
                                    <Grid size={{ md: 3, xs: 12 }}>
                                        <TextField
                                            required
                                            id="name"
                                            value={modeType === 'view' && data?.base_rate !== '' && data?.base_rate !== null && data?.base_rate !== undefined ? numberWithCommas(data?.base_rate) : (data?.base_rate ? data?.base_rate : '')}
                                            onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange("base_rate", e.target.value,) : e.preventDefault() }}
                                            label={`Base Rate${data?.interval?.label ? `/${data?.interval?.label}` : "" }`}
                                            variant="outlined"
                                            size="small"
                                            margin="normal"
                                            error={!!error.base_rate}
                                            helperText={error.base_rate}
                                            slotProps={{
                                                inputLabel: { shrink: true },
                                                htmlInput: {
                                                    maxLength: 11,
                                                },
                                                input: { startAdornment: (<InputAdornment position="start">{data?.currency?.symbol}</InputAdornment>) }
                                            }}
                                            onFocus={() => onRestErrorKey("base_rate")}
                                            fullWidth
                                            disabled={modeType === 'view'}
                                        />
                                    </Grid>
                                </Grid> : null}
                            </Box> : null}
                        </Box>
                    </Grid>
                    {data?.rental_type?.value === 2 ?
                        <Grid container sx={{ mt: 2, mb: 2 }}>
                            <CustomTable
                                leaseSlug={params.leaseSlug}
                                data={data}
                                onFieldChange={onFieldChange}
                                errors={error?.custom_payments}
                                onRestCustomPaymentFieldError={onRestCustomPaymentFieldError}
                                modeType={modeType}
                                onImportBackup={onImportBackup}
                            />
                        </Grid> : null}
                    {data?.interval?.value === 1 && data?.rental_type?.value === 1 ?
                        <Box className="escalation-container" sx={{ mt: 1 }} >
                            <Typography className='section-header-text'><u>Pro-rated Rate Details:</u></Typography>
                            <ProRateDetails onRestErrorKey={onRestErrorKey} data={data} onFieldChange={onFieldChange} modeType={modeType} error={error} />
                        </Box>
                        : null}
                    {[1, 3, 4].includes(data?.rental_type?.value) ?
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Box sx={{ width: '100%', mt: 1 }} className="escalation-container" >
                                <Typography className='section-header-text'><u>Escalation Details:</u></Typography>
                                <Box className="escalation-box" style={{ padding: '22px 12px 12px 12px' }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <TextField
                                                id="escalation_percentage"
                                                value={data?.escalation_percentage || ''}
                                                onChange={(e, value) => { regexConstants.percantageRegExp.test(e.target.value) ? onFieldChange('escalation_percentage', e.target.value) : e.preventDefault() }}
                                                label="Rental Rate Escalation %"
                                                variant="outlined"
                                                size="small"
                                                margin="normal"
                                                required={!data?.table_based_esc && (data?.escalation_interval !== null || data?.escalation_start_date !== null) ? true : false}
                                                error={!!error.escalation_percentage}
                                                onFocus={() => onRestErrorKey("escalation_percentage")}
                                                helperText={error.escalation_percentage}
                                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 6 }, input: { endAdornment: (<InputAdornment position="end">%</InputAdornment>) } }}
                                                fullWidth
                                                disabled={modeType === 'view' || data?.table_based_esc}
                                            />
                                        </Grid>
                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    label="Escalation Start Date"
                                                    value={data?.escalation_start_date ? moment(data.escalation_start_date) : null}
                                                    onChange={(data) => {
                                                        const isValid = moment(data)?.isValid();
                                                        const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                                                        onFieldChange("escalation_start_date", formattedDate);
                                                        if (isValid) {
                                                            onRestErrorKey("escalation_start_date");
                                                        }
                                                    }}

                                                    slotProps={{
                                                        textField: {
                                                            InputLabelProps: { shrink: true },
                                                            size: "small",
                                                            margin: "normal",
                                                            required: !data?.table_based_esc && (data?.escalation_percentage !== "" || data?.escalation_interval !== null),
                                                            helperText: error.escalation_start_date,
                                                            error: !!error.escalation_start_date,
                                                            onFocus: () => onRestErrorKey("escalation_start_date")
                                                        },
                                                        field: { clearable: true, onClear: () => { onFieldChange("escalation_start_date", null); } },
                                                    }}
                                                    sx={{ width: "100%" }}
                                                    format={fieldDateFormat}
                                                    disabled={modeType === 'view' || data?.table_based_esc}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Autocomplete
                                                disablePortal
                                                options={pltConstants?.constant_types?.filter(item => item.type === 'escalation_interval')}
                                                disabled={modeType === 'view'}
                                                noOptionsText={dropDownloader?.constantType ? "Loading..." : "No Option Available"}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={data?.escalation_interval || null}
                                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                onChange={(e, value) => { onFieldChange("escalation_interval", value); }}
                                                renderInput={(params) => {
                                                    const selectedLabel = params?.inputProps?.value || "";
                                                    return (
                                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow ><TextField  {...params} label="Escalation Interval" margin='normal' size='small'
                                                            required={(data?.escalation_percentage !== "" || data?.escalation_start_date !== null)}
                                                            error={Boolean(error?.escalation_interval)}
                                                            helperText={error?.escalation_interval}
                                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{dropDownloader?.constantType ? (<CircularProgress color="inherit" size={20} />) : null} {params?.InputProps?.endAdornment} </>) } }}
                                                            disabled={modeType === 'view'}
                                                        /></Tooltip>)}}
                                                required={!data?.table_based_esc && (data?.escalation_percentage !== "" || data?.escalation_start_date !== null)}
                                                error={!!error.escalation_interval}
                                                onFocus={() => onRestErrorKey("escalation_interval")}
                                                helperText={error.escalation_interval}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </Grid> : null}
                    <Grid container spacing={2}>
                        {data?.rental_type?.value === 2 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <FormGroup>
                                    <Box className="check-item-div" sx={{cursor: modeType === "view" ? "not-allowed" : "pointer"}}>
                                        <Checkbox checked={data?.is_additional_rate} onChange={(e) => { onFieldChange('is_additional_rate', e.target.checked) }} disabled={modeType === 'view'} disableRipple />
                                        <span className="check-item-span file-name">Additional Rent Applicable</span>
                                    </Box>
                                </FormGroup>
                                <TextField
                                    required={data?.is_additional_rate}
                                    id="margin"
                                    value={data?.margin || ''}
                                    onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('margin', e.target.value) : e.preventDefault() }}
                                    onFocus={() => onRestErrorKey("margin")}
                                    label="Dollar Margin (%)"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    sx={{ mt: '5px' }}
                                    error={error.margin}
                                    helperText={error.margin}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 5 }, input: { endAdornment: (<InputAdornment position="end">%</InputAdornment>) } }}
                                    fullWidth
                                    disabled={modeType === 'view' || !data?.is_additional_rate}
                                />
                            </Grid> : null}
                        {data?.interval?.value !== 1 ?
                            <Grid size={{ md: 3, xs: 12 }}>
                                <FormGroup className='disabled-checkbox-wrapper'>
                                    <Box className="check-item-div" sx={{ cursor: modeType === "view" ? 'not-allowed' : "pointer" }}>
                                        <Checkbox checked={data?.max_cap_applicable}
                                            onChange={(e) => {
                                                onFieldChange('max_cap_applicable', e.target.checked);
                                                if (!e.target.checked) {
                                                    onFieldChange('max_cap_amount', '');
                                                    onRestErrorKey('max_cap_amount');
                                                }
                                            }}
                                            disabled={modeType === 'view'} disableRipple sx={{ paddingLeft: 0 }} />
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', overflow: 'visible', whiteSpace: 'nowrap', cursor: "pointer", fontSize: "14px" }} >
                                            Enable Max Cap Amount
                                            <Tooltip title="Click here to enable max cap amount. Even Escalated Amount will be Restricted to this amount">
                                                <Box component="span" sx={{ display: 'inline-flex', ml: 0.5, }} > <InfoOutlineIcon fontSize="small" sx={{ fontSize: 16 }} /> </Box>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </FormGroup>
                                <TextField
                                    required={data?.max_cap_applicable}
                                    id="max_cap_amount"
                                    value={(modeType === 'view' || !data?.max_cap_applicable) && data?.max_cap_amount !== '' && data?.max_cap_amount !== null && data?.max_cap_amount !== undefined ? numberWithCommas(data?.max_cap_amount) : (data?.max_cap_amount || '')}
                                    onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('max_cap_amount', e.target.value) : e.preventDefault() }}
                                    onFocus={() => onRestErrorKey("max_cap_amount")}
                                    label="Enter Max Cap Amount"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    sx={{ mt: '5px' }}
                                    error={error.max_cap_amount}
                                    helperText={error.max_cap_amount}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{data?.currency?.symbol}</InputAdornment>) } }}
                                    fullWidth
                                    disabled={modeType === 'view' || !data?.max_cap_applicable}
                                />
                            </Grid> : null}
                        {/* {roudingCondition ? <Grid size={{ md: 4, xs: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper' sx={{ visibility: 'hidden' }}>
                                <Box className="check-item-div">
                                    <Checkbox disableRipple sx={{ paddingLeft: 0 }} />
                                    <span className="check-item-span">placeholder</span>
                                </Box>
                            </FormGroup>
                            <Autocomplete
                                disablePortal
                                options={pltConstants?.constant_types?.filter(item => item.type === 'round_off_escalation')}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.label || ""}
                                value={data?.round_off_escalation || null}
                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                onChange={(e, value) => onFieldChange("round_off_escalation", value)}
                                onFocus={() => onRestErrorKey("round_off_escalation")}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Esc. Rate Rounding"
                                        margin='normal'
                                        size='small'
                                        sx={{ mt: '5px' }}
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        disabled={modeType === 'view'}
                                    />
                                )}
                            />
                        </Grid> : null} */}
                    </Grid>
                    <Grid container spacing={2} >
                        <Grid size={{ md: 4, xs: 12 }} sx={{ mt: 2 }}>
                            <TextField
                                id="contractual_aggr_adj"
                                value={modeType === 'view' && data?.contractual_aggr_adj !== '' && data?.contractual_aggr_adj !== null && data?.contractual_aggr_adj !== undefined ? numberWithCommas(data?.contractual_aggr_adj) : (data?.contractual_aggr_adj ? data?.contractual_aggr_adj : '')}
                                onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('contractual_aggr_adj', e.target.value) : e.preventDefault() }}
                                label="Contractual Aggregation Adjustment"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 } }}
                                fullWidth
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        {/* <Grid size={{ md: 4, xs: 12 }} sx={{ mt: 2 }}>
                            <TextField
                                id="rent_schedule_name"
                                value={data?.rent_schedule_name ? data?.rent_schedule_name : ''}
                                onChange={(e, value) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('rent_schedule_name', e.target.value.trimStart()) : e.preventDefault() }}
                                label="Rent Schedule Name"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                fullWidth
                                disabled={modeType === 'view'}
                            />
                        </Grid> */}
                    </Grid>
                    <Grid container spacing={2} >
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 2 }}>
                            <TextField
                                id="remarks"
                                value={data?.rental_remark ?? ""}
                                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('rental_remark', e.target.value.trimStart()) : e.preventDefault() }}
                                label="Remarks"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true } }}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                fullWidth
                                rows={3}
                                multiline
                                disabled={modeType === 'view'}
                            />
                        </Grid>

                    </Grid>
                   
                    <Grid container spacing={2} >
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {data?.id && data?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditRentalRates?.data?.attachments?.length})Attachment(s)</Button> : <Button color='primary' variant='outlined' size='small' sx={{ marginBottom: '10px' }}>Attachments</Button>
                                }
                                <Button className='available-space-btn' size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); data?.rental_type?.value === 2 && modeType !== "add" && modeType !== "view" && getResponseBack(); handleItemClicked('Cancel Button') }} >{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditRentalRates() }}> Save </Button>}
                </DialogActions>
            </Dialog>
            {(isLoading || qbStatusLoading || qbDropDownLoader.productService || qbDropDownLoader.chartOfAccount || qbDropDownLoader.class) ? <PageLoader /> : null}
        </>

    )
}

export default RentalRateCRU

